import { createSelector } from "@reduxjs/toolkit";
import { getVariationDraftErrors } from "@src/store/slices/experienceBuilder/common/selectors/getVariationDraftErrors";
import { hasVariationDraftChanges } from "@src/store/slices/experienceBuilder/common/selectors/hasVariationDraftChanges";

export const getVariationDraftUIErrors = createSelector(
  getVariationDraftErrors,
  hasVariationDraftChanges,
  (errors, hasChanges) => {
    if (!hasChanges) {
      return undefined;
    }
    return errors;
  }
);
